export const sipStatusChangeLogic: Record<string, string[]> = {
  "": ["undefined"],
  Assigned: ["Assigned", "Unassigned", "Retired", "Reserved"],
  Hold: ["Hold", "Unassigned", "Retired", "Reserved"],
  Unassigned: ["Unassigned", "Retired", "Reserved"],
  Retired: ["Retired", "Unassigned"],
  Assigning: ["Assigning", "Unassigned", "Retired", "Reserved"],
  Reserved: ["Reserved", "Unassigned", "Retired"],
  Removing: ["Removing", "Unassigned", "Retired", "Reserved"],
  Error: ["Error", "Unassigned", "Retired", "Reserved"],
};
